function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { PureComponent } from "react";
import ParagraphAndAssetComponent from "/components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component";
import cloneDeep from "lodash/cloneDeep";
class MultipleTabsComponent extends PureComponent {
    tabsRenderer() {
        const { tabs } = this.props;
        return tabs.map((tab, index)=>{
            let { paragraphAndAssetColumns } = tab;
            let copyParagraphAndAssetColumns = cloneDeep(paragraphAndAssetColumns);
            if (copyParagraphAndAssetColumns && copyParagraphAndAssetColumns.content) {
                copyParagraphAndAssetColumns.content = _object_spread_props(_object_spread({}, copyParagraphAndAssetColumns.content), {
                    title: tab.tabLabel
                });
            }
            return /*#__PURE__*/ _createElement(ParagraphAndAssetComponent, _object_spread_props(_object_spread({}, copyParagraphAndAssetColumns), {
                key: index
            }));
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "multiple-tabs-component",
            children: this.tabsRenderer()
        });
    }
    constructor(props){
        super(props);
    }
}
export { MultipleTabsComponent as default };
MultipleTabsComponent.defaultProps = {
    tabs: []
};
